'use strict';

/**
* Function to control the progress bar for the banner carousel
* @param {Object} timerSliderSlider - the attribute of the slider-progress element
* @param {Object} tick - the interval for the progress bar
* @param {Object} percentTime - the percentage of time elapsed
* @param {Object} isPause - boolean to indicate if the progress bar is paused
* @param {Object} progressBar - the progress bar element
*/

module.exports = function () {
    var timerSliderSlider = $('.slider-progress').attr('attr');
    var tick; var percentTime; var
        isPause;
    var progressBar = $('.slider-progress .progress');

    $('.banner-carousel').on({
        mouseenter: function () {
            isPause = true;
        },
        mouseleave: function () {
            isPause = false;
        }
    });

    /**
    * Starts the progressbar and resets it
    */
    function startProgressbar() {
        resetProgressbar();
        percentTime = 0;
        isPause = false;
        tick = setInterval(interval, 10);
    }

    /**
    * Function that updates the progress bar for the banner carousel
    * @param {boolean} isPause - whether the progress bar is paused
    * @param {number} timerSliderSlider - the total time for the progress bar to complete
    * @param {Object} progressBar - the progress bar element
    */
    function interval() {
        if (isPause === false) {
            percentTime += 1 / timerSliderSlider;
            progressBar.css('width', percentTime + '%');
            if (percentTime >= 100) {
                $('.banner-carousel').slick('slickNext');
                startProgressbar();
            }
        }
    }

    /**
    * Resets the progressbar
    */
    function resetProgressbar() {
        progressBar.css('width', 0);
        clearTimeout(tick);
    }

    $('.banner-carousel').slick();

    startProgressbar();
};
